<template>
    <div class="strategy">
        <div class="title">使用攻略</div>
        <div class="strategyBox">
            <div class="strategyItem" v-for="(item, index) in strategyList" :key="'strategy' + index" :style="`background-image: url(${item.icon})`" @click="openUrl(item.url)">
                <p class="name">{{item.name}}</p>
                <p class="tip">{{item.tip}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            strategyList: [
                {
                    name: '发布活动',
                    tip: '发布活动卖票',
                    icon: require('../../../../assets/icon/index_1.png'),
                    url: 'https://mp.weixin.qq.com/s?__biz=MzU0NDU2ODM1OQ==&mid=2247485244&idx=3&sn=0ee70b74907cf5d9445b0621efeb4143&chksm=fb7b6274cc0ceb62e4f2c8568707efeabc2bcf41474477349830c5d27c99339abb70c0a6959d&scene=21#wechat_redirect',
                }, {
                    name: '导出选手',
                    tip: '一键导出报名数据',
                    icon: require('../../../../assets/icon/index_2.png'),
                    url: 'https://mp.weixin.qq.com/s/S3EVGx_otGbBqy3fM3r6cg'
                }, {
                    name: '收入提现',
                    tip: '活动提现秒到账',
                    icon: require('../../../../assets/icon/index_3.png'),
                    url: 'https://mp.weixin.qq.com/s?__biz=MzU0NDU2ODM1OQ==&mid=2247485454&idx=1&sn=df1e146ecda920b11349988ed9b77bf5&chksm=fb7b6d46cc0ce45033a7ba0f4a049585c8b90f7e0193d685437dec333fd31491128fbe5a86e6&scene=21#wechat_redirect'
                }, {
                    name: '线下检录',
                    tip: '线下活动检录扫码',
                    icon: require('../../../../assets/icon/index_4.png'),
                    url: 'https://mp.weixin.qq.com/s/S3EVGx_otGbBqy3fM3r6cg'
                }
            ]
        }
    },
    methods: {
        openUrl(url) {
            window.open(url)
        }
    },
}
</script>

<style lang="scss" scoped>
.strategy{
    margin-top: 16px;
}
.title{
    margin-bottom: 16px;
}
.strategyBox{
    overflow: hidden;
    padding: 10px 0;
    // display: flex;
    cursor: pointer;
    justify-content: space-between;
    .strategyItem{
        float: left;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        margin-right: 8px;
        width: 300px;
        height: 125px;
        box-sizing: border-box;
        padding: 0 0 0 36px;
        border-radius: 8px;
        background-position: 178px bottom;
        background-repeat: no-repeat;
        .name{
            font-size: 20px;
            font-weight: bold;
            margin-top: 36px;
        }
        .tip{
            font-size: 14px;
            margin-top: 9px;
        }
    }
    .strategyItem:nth-child(1) {
        background-size: 90px 93px;
    }
    .strategyItem:nth-child(2) {
        background-size: 87px 93px;
    }
    .strategyItem:nth-child(3) {
        background-size: 98px 93px;
    }
    .strategyItem:nth-child(4) {
        background-size: 80px 93px;
    }
    //178px bottom / 80px 93px no-repeat
}
</style>
